import { FC } from "react";

export const LvlPagi: FC<{
  totalPages: number;
  currentPage: number;
  handlePageChange: (page: number) => void;
}> = ({ totalPages, currentPage, handlePageChange }) => {
  if (!totalPages || totalPages <= 1) return null;
  return (
    <div className="flex justify-center mt-[4.375rem] space-x-[0.625rem]">
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`px-4 py-[0.625rem] rounded-[0.625rem] ${currentPage === i ? "bg-black text-white" : "bg-white"}`}
        >
          {i + 1}
        </button>
      ))}
      {currentPage < totalPages && (
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="w-10 h-10 flex items-center justify-center border rounded-[0.625rem] bg-white"
        >
          <svg
            width="5"
            height="10"
            viewBox="0 0 5 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.430908 1.00977C0.501221 0.939453 0.589111 0.904297 0.69458 0.904297C0.800049 0.904297 0.887939 0.939453 0.958252 1.00977L4.21606 4.2793C4.48169 4.54492 4.6145 4.86523 4.6145 5.24023C4.6145 5.61523 4.48169 5.93555 4.21606 6.20117L0.958252 9.4707C0.887939 9.54102 0.800049 9.57617 0.69458 9.57617C0.589111 9.57617 0.501221 9.54102 0.430908 9.4707C0.360596 9.39258 0.325439 9.30273 0.325439 9.20117C0.325439 9.09961 0.360596 9.00977 0.430908 8.93164L3.68872 5.67383C3.80591 5.55664 3.8645 5.41211 3.8645 5.24023C3.8645 5.06836 3.80591 4.92383 3.68872 4.80664L0.430908 1.54883C0.360596 1.4707 0.325439 1.38086 0.325439 1.2793C0.325439 1.17773 0.360596 1.08789 0.430908 1.00977ZM0.337158 0.927734C0.438721 0.826172 0.557861 0.775391 0.69458 0.775391C0.831299 0.775391 0.950439 0.826172 1.052 0.927734L4.30981 4.18555C4.59888 4.47461 4.74341 4.82617 4.74341 5.24023C4.74341 5.6543 4.59888 6.00586 4.30981 6.29492L1.052 9.55273C0.950439 9.6543 0.831299 9.70508 0.69458 9.70508C0.557861 9.70508 0.438721 9.6543 0.337158 9.55273C0.243408 9.45898 0.196533 9.3418 0.196533 9.20117C0.196533 9.06055 0.243408 8.94336 0.337158 8.84961L3.60669 5.5918C3.70044 5.49023 3.74731 5.37305 3.74731 5.24023C3.74731 5.10742 3.70044 4.99023 3.60669 4.88867L0.337158 1.63086C0.243408 1.53711 0.196533 1.41992 0.196533 1.2793C0.196533 1.13867 0.243408 1.02148 0.337158 0.927734ZM0.876221 1.10352C0.821533 1.05664 0.760986 1.0332 0.69458 1.0332C0.628174 1.0332 0.567627 1.05664 0.512939 1.10352C0.466064 1.15039 0.442627 1.20898 0.442627 1.2793C0.442627 1.34961 0.466064 1.4082 0.512939 1.45508L3.78247 4.71289C3.9231 4.86133 3.99341 5.03711 3.99341 5.24023C3.99341 5.44336 3.9231 5.61914 3.78247 5.76758L0.512939 9.02539C0.466064 9.07227 0.442627 9.13086 0.442627 9.20117C0.442627 9.27148 0.466064 9.33008 0.512939 9.37695C0.567627 9.42383 0.628174 9.44727 0.69458 9.44727C0.760986 9.44727 0.821533 9.42383 0.876221 9.37695L4.13403 6.11914C4.37622 5.87695 4.49731 5.58398 4.49731 5.24023C4.49731 4.89648 4.37622 4.60352 4.13403 4.36133L0.876221 1.10352Z"
              fill="#232323" />
          </svg>
        </button>
      )}
    </div>
  );
};
